export function safeUrl(value) {
  try {
    const url = new URL(value);
    return url.origin + url.pathname;
  } catch { return "[URL]"; }
}
export function cleanText(value) {
  return String(value)
    .replace(/https?:\/\/[^\s<>"']+/g, safeUrl)
    .replace(/(bearer\s+)[^\s,;]+/gi, "$1[Filtered]")
    .replace(/(?:sk-[A-Za-z0-9_-]{16,}|gh[pousr]_[A-Za-z0-9]+|github_pat_[A-Za-z0-9_]+)/g, "[Filtered]")
    .replace(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, "[email]")
    .slice(0, 2000);
}
export function scrubEvent(event) {
  const result = {};
  for (const key of ["event_id", "timestamp", "platform", "level", "release", "environment", "sdk"]) {
    if (event[key] !== undefined) result[key] = event[key];
  }
  result.tags = { component: "frontend" };
  if (event.exception?.values?.length) {
    result.exception = { values: event.exception.values.map(error => {
      const item = { type: cleanText(error.type || "Error"), value: cleanText(error.value || "") };
      if (error.mechanism) item.mechanism = { type: error.mechanism.type, handled: error.mechanism.handled };
      if (error.stacktrace?.frames) item.stacktrace = { frames: error.stacktrace.frames.map(frame => {
        const out = {};
        for (const key of ["filename", "function", "module", "lineno", "colno", "in_app"]) {
          if (frame[key] !== undefined) out[key] = typeof frame[key] === "string" ? cleanText(frame[key]) : frame[key];
        }
        return out;
      }) };
      return item;
    }) };
  } else if (event.message) result.message = cleanText(event.message);
  else return null;
  if (event.request) result.request = { method: event.request.method, url: safeUrl(event.request.url) };
  return result;
}
